import { myAxios } from "./helper";
import { getToken } from "./user-service";
import { toast } from "react-toastify";

export const income = (income, token) => {
    return myAxios.post("/income/", income, { headers: { authorization: token } }).then((response) => response.data);
};
export const getIncome = (token, userId) => {
    return myAxios.get('/income/' + userId, { headers: { authorization: token } }).then((response) => response.data.data);
};

export const updateIncome = (income, token,) => {
    return myAxios.put("/income/", income, { headers: { authorization: token } }).then((response) => response.data);
};

export const getSingleIncome = (token, id) => {
    return myAxios.get('/income/income/' + id, { headers: { authorization: token } })
      .then((response) => response.data.data)
      .catch(() => {
        toast.error("Error fetching single income:");
      });
  };
export const deleteIncome = (incomeId) => {
    let token = "Bearer " + getToken();
    return myAxios.delete(`/income/income/${incomeId}`, { headers: { authorization: token } }).then((response) => response.data);
}
export const downloadDocument1 = (id) => {
    let token = "Bearer " + getToken();
    return myAxios.get('/common/' + id, { responseType: "blob", headers: { authorization: token } });
}